import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Config } from '../../components';
import { ProductCategory } from '../../contracts';
import { ErrorHandler } from '../../util';
import { getAllProductCategoriesQuery } from './Queries/GetAllProductCategoriesQuery';
import { getProductCategoriesForCustomerPortalQuery } from './Queries/GetProductCategoriesForCustomerPortalQuery';

export class ProductCategoryApolloClient {

  private apolloClient: ApolloClient<NormalizedCacheObject>;

  constructor(identityToken: string, config: Config) {
    const httpLink = createHttpLink({
      uri: config.webAPIConfig.graphQlHttpApiUrl,
    });

    const authLink = setContext((_, { headers }) => ({
      headers: {
        ...headers,
        authorization: identityToken ? `Bearer ${identityToken}` : '',
      },
    }));

    this.apolloClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }

  public async getAllProductCategories(): Promise<Array<ProductCategory>> {
    try {
      const queryResult = await this.apolloClient.query({
        query: getAllProductCategoriesQuery,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      });

      return queryResult.data.productCategories;
    } catch (error) {
      ErrorHandler.handleError(error);
      return [];
    }
  }

  public async getProductCategoriesForCustomerPortal(isOther: boolean): Promise<Array<ProductCategory>> {
    try {
      const queryResult = await this.apolloClient.query({
        query: getProductCategoriesForCustomerPortalQuery,
        variables: { isOther },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
      });

      return queryResult.data.productCategoriesForCustomerPortal;
    } catch (error) {
      ErrorHandler.handleError(error);
      return [];
    }
  }
}
